import { Schema } from "../type-system/schema";

export const textMatchOperators = [
  "startsWith",
  "endsWith",
  "includes",
  "equals",
] as const;

export type StringMatchOperator = (typeof textMatchOperators)[number];

/** How each operator is named wherever a merchant reads or picks one. */
export const stringMatchOperatorToLabel: Record<StringMatchOperator, string> = {
  startsWith: "starts with",
  endsWith: "ends with",
  includes: "includes",
  equals: "equals",
};

export interface TextMatchExpression {
  type: "text_match";
  field: keyof Schema["fields"];
  operator: StringMatchOperator;
  matchValues: string[];
}
